import { render } from "./QatarPage.vue?vue&type=template&id=2a636f02&scoped=true"
import script from "./QatarPage.vue?vue&type=script&lang=js"
export * from "./QatarPage.vue?vue&type=script&lang=js"

import "./QatarPage.vue?vue&type=style&index=0&id=2a636f02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a636f02"]])

export default __exports__